import {
  MainPhotoSection,
  IncreaseSection,
} from "../../MainPage/MainPageStyles";
import FAQMainPhoto from "../../../images/faqMainPhoto.png";
import { NavLink } from "react-router-dom";
import LaptopPhoto from "../../../images/laptop__photo.png";
import { motion } from "framer-motion";
import {
  animationFromTheSide,
  arrAnimation,
} from "../../../animations/animations";
import { useTranslation } from "react-i18next";
import { useAppSelector } from "../../../store/hooks";
import { generateLink } from "../../../functions/routingFuntion";
import { useState } from "react";
import { Accordion } from "../../../components/Accordion/Accordion";

export const FAQ = () => {
  const [activeIndex, setActiveIndex] = useState<number | null>(null);
  const language = useAppSelector((state) => state.locale.localStorageValue);
  const { t } = useTranslation();

  const handleToggle = (index: number) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <main>
      <MainPhotoSection style={{ background: "#074275" }}>
        <motion.div
          initial="hidden"
          whileInView="visible"
          viewport={{ amount: 0.3, once: true }}
          className="container__standart flex__between flex__column"
          style={{ marginBottom: "0px" }}
        >
          <motion.div custom={1} variants={arrAnimation}>
            <h1>{t("faqPage.title1")}</h1>
          </motion.div>
          <motion.div custom={2} variants={arrAnimation}>
            <img src={FAQMainPhoto} alt="#" />
          </motion.div>
        </motion.div>
      </MainPhotoSection>
      <section>
        <div
          className="container__standart"
          style={{ marginBottom: "3.75rem" }}
        >
          <motion.h2
            initial="hidden"
            whileInView="visible"
            viewport={{ amount: 0.3, once: true }}
            variants={animationFromTheSide}
          >
            {t("faqPage.blockInfo1Tit")}
          </motion.h2>
        </div>
        <div className="container__standart">
          {[
            t("faqPage.blockInfo111"),
            t("faqPage.blockInfo121"),
            t("faqPage.blockInfo131"),
            t("faqPage.blockInfo141"),
            t("faqPage.blockInfo151"),
            t("faqPage.blockInfo161"),
          ].map((title, index) => (
            <Accordion
              key={index}
              title={title}
              isOpen={activeIndex === index}
              onToggle={() => handleToggle(index)}
            >
              {index === 0 && t("faqPage.blockInfo112")}
              {index === 1 && t("faqPage.blockInfo122")}
              {index === 2 && t("faqPage.blockInfo132")}
              {index === 3 && t("faqPage.blockInfo142")}
              {index === 4 && t("faqPage.blockInfo152")}
              {index === 5 && t("faqPage.blockInfo162")}
            </Accordion>
          ))}
        </div>
      </section>
      <IncreaseSection>
        <motion.div
          initial="hidden"
          whileInView="visible"
          viewport={{ amount: 0.3, once: true }}
          className="flex__between container__standart"
        >
          <motion.div
            custom={1}
            variants={arrAnimation}
            className="web-terminal__info"
          >
            <h2> {t("faqPage.blockInfo2Tit")}</h2>
            <NavLink
              className="white__button flex__center"
              to={generateLink("/auth/register", language)}
            >
              {t("faqPage.blockInfo21")}
            </NavLink>
          </motion.div>
          <motion.div
            custom={2}
            variants={arrAnimation}
            className="web-terminal__photo"
          >
            <img src={LaptopPhoto} alt="Laptop" />
          </motion.div>
        </motion.div>
      </IncreaseSection>
    </main>
  );
};
